
let fr = {}
// 定义如下响应式数据
// 是否有路由实例了
Vue.util.defineReactive(fr, "hasRouteIns", false)
// 是否就绪, 是否真正开始渲染应用页面了
Vue.util.defineReactive(fr, "isReady", true)
// 路由方向的判断, "前进 -> forward" "后退 -> back"
Vue.util.defineReactive(fr, "direction", "")

// 当路由发生改变时，vue-router会通过pushState种下每次改变的state,其key值为当时的毫秒数
// "curKey"用于保存当前页面对应的history.state.key的值,用于每次路由改变时，通过比较大小来确定路由的前进或后退
Vue.util.defineReactive(fr, "curKey", 0)

// "prevKey"用于保存上一个页面对应的history.state.key的值
Vue.util.defineReactive(fr, "prevKey", 0)

// 在单次路由切换过程中，是更新了当前路由还是跳转了路由；
// type取值：'goto'表示跳转到新路由、'update'表示更新当前路由 
Vue.util.defineReactive(fr, "routeType", "")

Vue.util.defineReactive(fr, "routeMode", "")


export default fr